(function () {
"use strict";
var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
var items = document.querySelectorAll(".reveal");
if (reduced) {
items.forEach(function (el) { el.classList.add("in"); });
} else {
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) {
if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
});
}, { threshold: 0.15, rootMargin: "0px 0px -50px 0px" });
items.forEach(function (el) { io.observe(el); });
}
document.querySelectorAll(".provas-track").forEach(function (pista) {
var originais = pista.children.length;
pista.innerHTML += pista.innerHTML;
[].slice.call(pista.children, originais).forEach(function (c) {
c.setAttribute("aria-hidden", "true");
});
});
document.querySelectorAll(".provas").forEach(function (fila) {
fila.addEventListener("click", function (e) {
e.stopPropagation();
fila.classList.toggle("parada");
});
});
document.addEventListener("click", function () {
document.querySelectorAll(".provas.parada").forEach(function (f) { f.classList.remove("parada"); });
});
document.querySelectorAll(".provas, .galeria-grelha, .muro-fita").forEach(function (caixa) {
caixa.addEventListener("contextmenu", function (e) { e.preventDefault(); });
caixa.addEventListener("dragstart", function (e) { e.preventDefault(); });
caixa.querySelectorAll("img").forEach(function (im) { im.draggable = false; });
});
var videos = document.querySelectorAll("video[data-auto]");
if (videos.length) {
var semInline = false;
videos.forEach(function (v) {
v.playsInline = true;
v.disablePictureInPicture = true;
});
var falhou = function (v) {
var caixa = v.closest(".palco") || v.parentElement;
if (!caixa || caixa.querySelector(".toca")) return;
var b = document.createElement("button");
b.type = "button";
b.className = "toca";
b.setAttribute("aria-label", "Reproduzir");
b.addEventListener("click", function (e) {
e.stopPropagation();
v.dataset.aMao = "1";
v.play().then(function () { b.remove(); }, function () {});
});
caixa.appendChild(b);
};
var arrancou = function (v) {
var caixa = v.closest(".palco") || v.parentElement;
var b = caixa && caixa.querySelector(".toca");
if (b) b.remove();
};
var tentar = function (v) {
if (semInline) return;
if (!v.paused) { arrancou(v); return; }
v.muted = true;
v.playsInline = true;
var p = v.play();
if (!p || !p.then) return;
p.then(function () { arrancou(v); }, function (erro) {
if (erro && erro.name === "NotAllowedError") { falhou(v); return; }
if (v.dataset.reTentado) { falhou(v); return; }
v.dataset.reTentado = "1";
v.addEventListener("canplay", function () { tentar(v); }, { once: true });
});
};
{
var barras = new Map();
document.querySelectorAll(".palco").forEach(function (palco) {
var v = palco.querySelector("video[data-auto]");
if (!v) return;
var b = document.createElement("div");
b.className = "progresso";
b.setAttribute("aria-hidden", "true");
palco.appendChild(b);
barras.set(v, b);
});
var aVer = new Set();
var pinta = null;
var pintar = function () {
aVer.forEach(function (v) {
var b = barras.get(v);
if (!b) return;
var d = v.duration;
var p = d > 0 ? (v.currentTime / d).toFixed(4) : "0";
if (b.dataset.p !== p) { b.dataset.p = p; b.style.setProperty("--p", p); }
});
pinta = aVer.size ? requestAnimationFrame(pintar) : null;
};
var vio = new IntersectionObserver(function (es) {
es.forEach(function (e) {
var v = e.target;
if (e.isIntersecting) {
tentar(v);
aVer.add(v);
clearTimeout(v.guarda);
v.guarda = setTimeout(function () {
if (v.paused) falhou(v);
}, 9000);
} else {
v.pause();
aVer.delete(v);
clearTimeout(v.guarda);
delete v.dataset.reTentado;
}
});
if (!pinta && aVer.size) pinta = requestAnimationFrame(pintar);
}, { threshold: 0.25 });
var desistir = function (v) {
if (semInline) return;
semInline = true;
if (!v.dataset.aMao) {
try { if (v.webkitExitFullscreen) v.webkitExitFullscreen(); } catch (e) {}
try { if (document.exitFullscreen) document.exitFullscreen(); } catch (e) {}
}
clearInterval(vigia);
vio.disconnect();
videos.forEach(function (o) {
clearTimeout(o.guarda);
aVer.delete(o);
var barra = barras.get(o);
if (barra) barra.remove();
if (o !== v) { try { o.pause(); } catch (e) {} }
if (o.paused) falhou(o);
});
};
videos.forEach(function (v) {
vio.observe(v);
v.addEventListener("webkitbeginfullscreen", function () { desistir(v); });
v.addEventListener("fullscreenchange", function () {
if (document.fullscreenElement === v) desistir(v);
});
v.addEventListener("error", function () { falhou(v); });
var fonte = v.querySelector("source");
if (fonte) fonte.addEventListener("error", function () { falhou(v); });
});
var ronda = 0;
var vigia = setInterval(function () {
if (++ronda > 3) { clearInterval(vigia); return; }
videos.forEach(function (v) {
if (!v.paused) return;
var r = v.getBoundingClientRect();
if (r.bottom > 0 && r.top < innerHeight) tentar(v);
});
}, 5000);
}
}
if (!reduced) {
var pausaveis = document.querySelectorAll(".burst, .provas-track, .palco .quadro, .muro-track");
if (pausaveis.length && "IntersectionObserver" in window) {
var pio = new IntersectionObserver(function (es) {
es.forEach(function (e) {
e.target.style.animationPlayState = e.isIntersecting ? "" : "paused";
});
}, { rootMargin: "200px 0px" });
pausaveis.forEach(function (el) { pio.observe(el); });
}
}
var grelha = document.querySelector(".galeria-grelha");
if (grelha) {
var cartoes = [].slice.call(grelha.querySelectorAll("figure"));
var botoes = [].slice.call(document.querySelectorAll(".gf"));
var emViagem = 0;
var acender = function (tema) {
botoes.forEach(function (x) {
var esta = x.getAttribute("data-tema") === tema;
x.classList.toggle("ativa", esta);
x.setAttribute("aria-pressed", esta ? "true" : "false");
});
};
var quadro = null;
var centros = [], meioEcra = 0, largCartao = 1, inicio = 0;
var medir = function () {
meioEcra = grelha.clientWidth / 2;
largCartao = cartoes.length ? cartoes[0].offsetWidth : 1;
centros = cartoes.map(function (c) { return c.offsetLeft + c.offsetWidth / 2; });
inicio = cartoes.length > 1 ? Math.max(0, centros[1] - meioEcra) : 0;
};
var focar = function () {
quadro = null;
var meio = grelha.scrollLeft + meioEcra;
var perto = null, menor = Infinity;
for (var i = 0; i < cartoes.length; i++) {
var c = cartoes[i];
var d = centros[i] - meio;
var a = Math.abs(d);
if (a < menor) { menor = a; perto = c; }
if (reduced) continue;
if (a > largCartao * 2.2 && c.dataset.f) continue;
c.dataset.f = "1";
var t = Math.min(a / largCartao, 1);
var lado = Math.max(-1, Math.min(1, d / largCartao));
c.style.transform = "perspective(900px) translateX(" + (-16 * lado * t).toFixed(1) + "px) rotateY(" + (-7 * lado).toFixed(2) + "deg) scale(" + (1 - t * 0.1).toFixed(3) + ")";
c.style.opacity = (1 - t * 0.42).toFixed(3);
c.style.zIndex = String(20 - Math.round(t * 10));
}
if (perto && Date.now() > emViagem) acender(perto.getAttribute("data-t"));
};
grelha.addEventListener("scroll", function () {
if (!quadro) quadro = requestAnimationFrame(focar);
}, { passive: true });
addEventListener("resize", function () {
medir();
if (!quadro) quadro = requestAnimationFrame(focar);
}, { passive: true });
var viagem = null;
var viajar = function (x) {
if (viagem) { cancelAnimationFrame(viagem); viagem = null; }
var de = grelha.scrollLeft;
var dist = x - de;
if (reduced || Math.abs(dist) < 2) { grelha.scrollLeft = x; return; }
var dur = Math.min(2200, 700 + Math.abs(dist) * 0.35);
emViagem = Date.now() + dur + 400;
var t0 = null;
var passo = function (t) {
if (!t0) t0 = t;
var p = Math.min((t - t0) / dur, 1);
var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
grelha.scrollLeft = de + dist * e;
viagem = p < 1 ? requestAnimationFrame(passo) : null;
};
viagem = requestAnimationFrame(passo);
};
["touchstart", "wheel"].forEach(function (ev) {
grelha.addEventListener(ev, function () {
if (viagem) { cancelAnimationFrame(viagem); viagem = null; emViagem = 0; }
}, { passive: true });
});
botoes.forEach(function (b) {
b.addEventListener("click", function () {
var tema = b.getAttribute("data-tema");
var alvo = -1;
for (var i = 0; i < cartoes.length; i++) {
if (cartoes[i].getAttribute("data-t") === tema) { alvo = i; break; }
}
if (alvo < 0) return;
acender(tema);
viajar(centros[alvo] - meioEcra);
});
});
if (!reduced && "IntersectionObserver" in window) {
var mexeu = false;
grelha.addEventListener("touchstart", function () { mexeu = true; }, { passive: true, once: true });
new IntersectionObserver(function (es, obs) {
if (!es[0].isIntersecting) return;
obs.disconnect();
setTimeout(function () {
if (mexeu || viagem || Math.abs(grelha.scrollLeft - inicio) > 4) return;
var t0 = null;
var passo = function (t) {
if (!t0) t0 = t;
var p = Math.min((t - t0) / 900, 1);
grelha.scrollLeft = inicio + Math.sin(p * Math.PI) * 56;
if (p < 1 && !mexeu) requestAnimationFrame(passo);
};
requestAnimationFrame(passo);
}, 900);
}, { threshold: 0.6 }).observe(grelha);
}
medir();
grelha.scrollLeft = inicio;
focar();
}
var conta = document.querySelector(".muro-conta b");
if (conta && !reduced && "IntersectionObserver" in window) {
var fimConta = parseInt(conta.getAttribute("data-fim"), 10) || 100;
conta.textContent = "0";
new IntersectionObserver(function (es, obs) {
if (!es[0].isIntersecting) return;
obs.disconnect();
var t0 = null;
var passo = function (t) {
if (!t0) t0 = t;
var p = Math.min((t - t0) / 1400, 1);
conta.textContent = Math.round(fimConta * (1 - Math.pow(1 - p, 3)));
if (p < 1) requestAnimationFrame(passo);
};
requestAnimationFrame(passo);
}, { threshold: 0.7 }).observe(conta);
}
var float = document.querySelector(".float-cta");
var botoesReais = [].slice.call(document.querySelectorAll("main .btn"));
if (float && botoesReais.length > 1) {
var noEcra = function (el) {
var r = el.getBoundingClientRect();
return r.bottom > 0 && r.top < innerHeight;
};
var algumNoEcra = function () {
for (var i = 0; i < botoesReais.length; i++) {
if (noEcra(botoesReais[i])) return true;
}
return false;
};
var jaPassouUmBotao = function () {
for (var i = 1; i < botoesReais.length; i++) {
if (botoesReais[i].getBoundingClientRect().bottom < 0) return true;
}
return false;
};
var tick = null;
var paint = function () {
tick = null;
float.classList.toggle("on", jaPassouUmBotao() && !algumNoEcra());
};
addEventListener("scroll", function () {
if (!tick) tick = requestAnimationFrame(paint);
}, { passive: true });
addEventListener("resize", function () {
if (!tick) tick = requestAnimationFrame(paint);
}, { passive: true });
paint();
}
var carril = document.querySelector(".jornada .linha");
if (carril && !reduced) {
var degraus = [].slice.call(carril.querySelectorAll(".marco"));
if (degraus.length) {
var palco = carril.parentNode;
var raiz = palco || document;
var pecas = [].slice.call(raiz.querySelectorAll(".vitrine .peca"));
var pilha = raiz.querySelector(".vitrine .pilha");
var pisos = pilha ? [].slice.call(pilha.querySelectorAll(".degrau-pir")) : [];
var legenda = pilha ? pilha.querySelector("figcaption") : null;
var legendaZero = legenda ? legenda.textContent : "";
var placar = raiz.querySelector(".vitrine-conta");
var marcas = [];
var medirCarril = function () {
var base = carril.getBoundingClientRect();
if (!base.height) return;
marcas = degraus.map(function (d) {
var r = d.getBoundingClientRect();
return (r.top - base.top + 13) / base.height;
});
};
var pintou = null;
var pintarCarril = function () {
pintou = null;
var r = carril.getBoundingClientRect();
if (!r.height) return;
var p = (innerHeight * 0.6 - r.top) / r.height;
if (p < 0) p = 0; else if (p > 1) p = 1;
carril.style.setProperty("--p", p.toFixed(4));
var pir = 0;
var kit = 0;
for (var i = 0; i < degraus.length; i++) {
var d = degraus[i];
var aceso = p >= marcas[i];
d.classList.toggle("aceso", aceso);
var lugar = d.getAttribute("data-peca");
if (lugar && pecas[lugar - 1]) {
pecas[lugar - 1].classList.toggle("tem", aceso);
if (aceso) kit++;
}
var nivel = d.getAttribute("data-pir");
if (nivel && aceso && +nivel > pir) pir = +nivel;
}
if (placar) {
var soma = kit + pir;
var texto = soma + " de 8";
if (placar.textContent !== texto) placar.textContent = texto;
placar.classList.toggle("tem", soma > 0);
}
if (pilha) {
pilha.classList.toggle("tem", pir > 0);
var nome = legendaZero;
for (var j = 0; j < pisos.length; j++) {
var esta = +pisos[j].getAttribute("data-nivel") === pir;
pisos[j].classList.toggle("mostra", esta);
if (esta) nome = pisos[j].getAttribute("data-nome") || nome;
}
if (legenda && legenda.textContent !== nome) legenda.textContent = nome;
}
};
var pedirCarril = function () {
if (!pintou) pintou = requestAnimationFrame(pintarCarril);
};
carril.classList.add("viva");
if (palco) palco.classList.add("viva");
medirCarril();
pintarCarril();
addEventListener("scroll", pedirCarril, { passive: true });
addEventListener("resize", function () { medirCarril(); pedirCarril(); }, { passive: true });
addEventListener("load", function () { medirCarril(); pedirCarril(); });
}
}
var aviso = document.getElementById("aviso-cookies");
if (aviso && window.Shopify && typeof window.Shopify.loadFeatures === "function") {
var raizHtml = document.documentElement;
var medirAviso = function () {
raizHtml.style.setProperty("--h-aviso", aviso.offsetHeight + "px");
};
var fecharAviso = function () {
aviso.classList.remove("on");
raizHtml.classList.remove("com-aviso");
removeEventListener("resize", medirAviso);
setTimeout(function () { aviso.hidden = true; }, 420);
};
var gravar = function (escolha) {
try {
window.Shopify.customerPrivacy.setTrackingConsent({
analytics: !!escolha.analytics,
marketing: !!escolha.marketing,
preferences: !!escolha.preferences,
sale_of_data: false
}, function () {});
} catch (e) {}
fecharAviso();
};
var todos = function (sim) {
gravar({ analytics: sim, marketing: sim, preferences: sim });
};
window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (erro) {
if (erro) return;
var cp = window.Shopify.customerPrivacy;
if (!cp || typeof cp.shouldShowBanner !== "function" || !cp.shouldShowBanner()) return;
var opcoes = aviso.querySelector(".aviso-opcoes");
var btMais = aviso.querySelector(".aviso-mais");
var btGuardar = aviso.querySelector(".aviso-guardar");
aviso.querySelector(".aviso-sim").addEventListener("click", function () { todos(true); });
aviso.querySelector(".aviso-nao").addEventListener("click", function () { todos(false); });
btMais.addEventListener("click", function () {
opcoes.hidden = false;
btMais.hidden = true;
btGuardar.hidden = false;
medirAviso();
});
btGuardar.addEventListener("click", function () {
var escolha = {};
opcoes.querySelectorAll("input[data-c]").forEach(function (c) {
escolha[c.getAttribute("data-c")] = c.checked;
});
gravar(escolha);
});
aviso.hidden = false;
medirAviso();
addEventListener("resize", medirAviso, { passive: true });
raizHtml.classList.add("com-aviso");
requestAnimationFrame(function () {
requestAnimationFrame(function () { aviso.classList.add("on"); });
});
});
}
})();